export const PERMS = {
    READ: 'report_vehicle_performance.read',
    UPDATE: 'report_vehicle_performance.update',
    DELETE: 'report_vehicle_performance.delete',
    CREATE: 'report_vehicle_performance.create',
    EXPORT: 'report_vehicle_performance.export',
}
